export enum ModalType {
  MainNavigation,
  Profile,
  TaskDetail,
  TeamSelection,
  SuperUsersList,
  MultiSelectTasks,
}
